/* Google review widget is a storefront feature; analytics and advertising follow Shopify consent. */
(() => {
  'use strict';
  let api;
  let reviewsLoaded = false;
  let last = {preferences: false, analytics: false, marketing: false};
  let reloading = false;

  function allowed() {
    return {
      preferences: api.preferencesProcessingAllowed(),
      analytics: api.analyticsProcessingAllowed(),
      marketing: api.marketingAllowed()
    };
  }

  function loadReviews() {
    if (reviewsLoaded || !document.querySelector('template[data-tm-reviews]')) return;
    reviewsLoaded = true;
    document.querySelectorAll('template[data-tm-reviews]').forEach(template => {
      template.replaceWith(template.content.cloneNode(true));
    });
    const script = document.createElement('script');
    script.src = 'https://cdn.grw.reputon.com/assets/widget.js?shop=www.tretmaschine.shop';
    script.async = true;
    script.onload = () => {
      document.querySelectorAll('[data-tm-reviews-placeholder]').forEach(node => node.hidden = true);
      document.dispatchEvent(new Event('tm:reviews-loaded'));
    };
    script.onerror = () => {
      document.querySelectorAll('[data-tm-reviews-placeholder]').forEach(node => {
        node.textContent = 'Die Google-Bewertungen sind gerade nicht erreichbar.';
      });
    };
    document.head.appendChild(script);
  }

  function update() {
    if (!api) return;
    const state = allowed();
    window.gtag('consent', 'update', {
      analytics_storage: state.analytics ? 'granted' : 'denied',
      ad_storage: state.marketing ? 'granted' : 'denied',
      ad_user_data: state.marketing ? 'granted' : 'denied',
      ad_personalization: state.marketing ? 'granted' : 'denied',
      functionality_storage: state.preferences ? 'granted' : 'denied',
      personalization_storage: state.preferences ? 'granted' : 'denied'
    });
    if (Object.keys(last).some(key => last[key] && !state[key]) && !reloading) {
      // An already-running third-party script cannot be unloaded in place.
      reloading = true;
      window.location.reload();
      return;
    }
    last = state;
  }

  function init(error) {
    if (error || !window.Shopify?.customerPrivacy || api) return;
    api = window.Shopify.customerPrivacy;
    update();
    document.addEventListener('visitorConsentCollected', update);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') update();
    });
  }

  let attempts = 0;
  function load() {
    loadReviews();
    if (window.Shopify?.customerPrivacy) return init();
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], init);
      return;
    }
    if (++attempts < 40) window.setTimeout(load, 250);
  }
  load();
})();
